if (!customElements.get('notify-me-form')) {
  customElements.define(
    'notify-me-form',
    class NotifyMeForm extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        this.toggle = this.querySelector('.notify-me-form__toggle');
        this.fields = this.querySelector('.notify-me-form__fields');
        this.form = this.querySelector('form');
        this.productHandle = this.getProductHandle();

        if (this.productHandle && this.isSubscribed()) {
          this.markSubscribed();
          return;
        }

        if (this.toggle && this.fields) {
          this.toggle.addEventListener('click', this.onToggleClick.bind(this));
        }

        if (this.form) {
          this.form.addEventListener('submit', this.onSubmit.bind(this));
        }
      }

      getProductHandle() {
        const tagsInput = this.form && this.form.querySelector('input[name="contact[tags]"]');
        if (!tagsInput) return null;
        return tagsInput.value.replace(/^notify-restock-/, '');
      }

      storageKey() {
        return `notify-restock:${this.productHandle}`;
      }

      isSubscribed() {
        try {
          return window.localStorage.getItem(this.storageKey()) === '1';
        } catch (error) {
          return false;
        }
      }

      persistSubscribed() {
        try {
          window.localStorage.setItem(this.storageKey(), '1');
        } catch (error) {
          // localStorage unavailable (private browsing, storage full, etc.) —
          // the submission itself still succeeded, it just won't survive a refresh.
        }
      }

      markSubscribed() {
        if (this.toggle) {
          this.toggle.hidden = false;
          this.toggle.disabled = true;
          this.toggle.setAttribute('aria-expanded', 'false');
          this.toggle.textContent = this.dataset.subscribedText || this.toggle.textContent;
        }
        if (this.fields) {
          this.fields.hidden = true;
        }
      }

      onToggleClick() {
        this.fields.hidden = false;
        this.toggle.setAttribute('aria-expanded', 'true');
        this.toggle.hidden = true;
        this.fields.querySelector('input[type="email"]').focus();
      }

      async onSubmit(event) {
        event.preventDefault();

        const submitButton = this.form.querySelector('[type="submit"]');
        if (submitButton) submitButton.setAttribute('aria-disabled', 'true');

        const returnToInput = this.form.querySelector('input[name="return_to"]');
        const returnToUrl = returnToInput ? returnToInput.value.split('#')[0] : null;

        try {
          const response = await fetch(this.form.action, {
            method: 'POST',
            body: new FormData(this.form),
          });
          const html = await response.text();
          let updated = new DOMParser().parseFromString(html, 'text/html').getElementById(this.id);

          if (!updated && returnToUrl) {
            // The POST response didn't contain our markup (e.g. it landed somewhere
            // other than the product page) — explicitly fetch the return_to page,
            // which is where the form's own redirect should have taken us.
            const returnToResponse = await fetch(returnToUrl);
            const returnToHtml = await returnToResponse.text();
            updated = new DOMParser().parseFromString(returnToHtml, 'text/html').getElementById(this.id);
          }

          if (!updated) throw new Error('notify-me-form: matching element not found in response');

          const hasError = updated.querySelector('input[aria-invalid="true"]');

          if (hasError) {
            this.innerHTML = updated.innerHTML;
            this.init();
            const invalidInput = this.querySelector('input[aria-invalid="true"]');
            if (invalidInput) invalidInput.focus();
            return;
          }

          this.persistSubscribed();
          this.markSubscribed();
        } catch (error) {
          // Native fallback: a normal full-page submit still works correctly,
          // it just loses the inline, no-reload experience.
          this.form.submit();
        }
      }
    }
  );
}
